/** Values the branding logo field may hold after re-hosting or before save. */
export function isAcceptableLogoUrl(value) {
  if (!value) return true;
  const text = String(value).trim();
  if (!text) return true;
  if (text.startsWith('/media/') && !text.includes('..')) return true;
  return /^https?:\/\//i.test(text);
}

export const LOGO_MAX_BYTES = 5 * 1024 * 1024;
/** Data-URL previews inflate ~33%; skip above this so a 5 MB file does not freeze the tab. */
export const LOGO_IN_MEMORY_PREVIEW_MAX_BYTES = 1024 * 1024;
const LOGO_TYPES = new Set(['image/png', 'image/jpeg', 'image/jpg', 'image/webp', 'image/gif']);
const LOGO_NAME = /\.(png|jpe?g|webp|gif)$/i;

function looksLikeLogoFile(file) {
  const type = (file.type || '').split(';')[0].trim().toLowerCase();
  if (LOGO_TYPES.has(type)) return true;
  // Safari/Finder often send an empty type or application/octet-stream.
  if ((!type || type === 'application/octet-stream') && LOGO_NAME.test(file.name || '')) {
    return true;
  }
  return false;
}

/** Client-side check aligned with backend save_uploaded_logo (bytes, not Content-Type). */
export function logoFileRejectReason(file) {
  if (!file) return 'Choose an image file.';
  if (!looksLikeLogoFile(file)) {
    return 'Use PNG, JPEG, WebP, or GIF.';
  }
  if (file.size > LOGO_MAX_BYTES) {
    return 'Logo is larger than 5 MB.';
  }
  return null;
}

export function shouldPreviewLogoFileInMemory(file) {
  return Boolean(file) && file.size <= LOGO_IN_MEMORY_PREVIEW_MAX_BYTES;
}
